import type { LoginProps } from "@bluframe/blublocks"

import Login from "./Login"

export interface Props extends LoginProps {}

export interface ComponentProps extends Props {}

export default Login
